var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Logo'),_c('div',[_c('img',{staticClass:"bg",attrs:{"src":_vm.image}})]),_c('NewsBar'),_c('div',{staticStyle:{"height":"5.125rem"}},[_c('Tabbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }